export class Occupation {
    id: number;
    code: string;
    name: string;
    version: string;
    parent:Occupation;
}